<template>
  <v-layout>

    <v-layout column class="align-self-start">
      <v-flex xs12 sm6>

        <v-layout row wrap>
          <v-flex>
            <v-form action="" ref="transferForm" v-if="storeTransferExecuted === false">

              <v-text-field
                v-model="selectedUserEmail"
                @change="validateUser()"
                label="Enter employee's email ID"
                v-validate="'required'"
                :error-messages="errors.collect('slot1.selectedUserEmail')"
                data-vv-name="slot1.selectedUserEmail"
                data-vv-scope="slot1"
                data-vv-validate-on="blur"
              ></v-text-field>

              <v-flex class="md6" v-if="userDetails"
                   style="display: flex; justify-content: space-around; align-items: center;">
                <div style="text-align: center">
                  <strong>{{ userDetails }}</strong><br>
                  <em>{{ selectedUserEmail }}</em>
                </div>
                <v-avatar
                  size="100,120"
                  :tile=true
                  color="primary"
                  v-if="selectedUser"
                >
                  <img :src="userImage" style="height:120px; width:100px;" alt="Avatar">
                </v-avatar>
              </v-flex>

              <v-text-field
                @blur="validateStore('store1')"
                v-validate="'required'"
                :error-messages="errors.collect('slot1.storeCode')"
                data-vv-name="slot1.storeCode"
                data-vv-scope="slot1"
                data-vv-validate-on="blur"

                v-model="storeCode"
                label="Enter employee's store ID"
                :hint="store1Details"
                persistent-hint
                type="number"
              ></v-text-field>

              <v-flex v-if="!isXs" style="display:flex; justify-content: space-between;margin-top: 20px;" >
                <v-btn @click="goToHome" >Cancel</v-btn>
                <v-btn color="success"
                       :disabled="isButtonDisabled"
                       @click="updateStore">Activate employee</v-btn>
              </v-flex>
              <v-flex v-if="isXs" style="margin-top: 20px;" >
                <v-btn color="success"
                       :disabled="isButtonDisabled"
                       block @click="updateStore">Activate employee</v-btn>
                <v-btn @click="goToHome"  style="margin-top: 10px;" block>Cancel</v-btn>
              </v-flex>
            </v-form>
            <div v-if="loading" style="height:200px; display: flex;align-items: center; justify-content: center">
              <h2>Loading...</h2>
            </div>
            <div v-if="storeTransferExecuted === true">
              <div v-if="storeTransferExecutedSuccess">
                <v-alert
                  :value="true"
                  color="success"
                  icon="check_circle"
                  outline
                >
                  Employee <strong>{{getUser(selectedUser).firstName}} {{getUser(selectedUser).lastName}} ({{getUser(selectedUser).email}})</strong>
                  has been activated.
                </v-alert>
                <br><br>
                <strong>Store ID:</strong> {{storeCode}}  ({{store1Details}})

                <v-flex style="display:flex; justify-content: space-between;margin-top: 30px;">
                  <v-btn color="primary" @click="goToHome" block>Home</v-btn>
                </v-flex>

              </div>
              <div v-if="storeTransferExecutedFailed === true">
                <v-alert
                  :value="true"
                  color="error"
                  icon="warning"
                  outline
                >
                  Whoops! Something went wrong.
                </v-alert>
                <br> <br>
                <p>
                  Employee <strong>{{getUser(selectedUser).firstName}} {{getUser(selectedUser).lastName}} ({{getUser(selectedUser).email}})</strong>
                  failed to activate.
                </p>
                <v-flex style="display:flex; justify-content: space-between;">
                  <v-btn @click="goToHome">Home</v-btn>
                  <v-btn color="success" @click="goToSupport">Open support ticket</v-btn>
                </v-flex>
              </div>
            </div>
          </v-flex>
        </v-layout>

      </v-flex>
    </v-layout>

    <v-dialog v-model="confirmDialog"
              v-if="confirmDialog"
              width="500"
              persistent
              transition="dialog-bottom-transition">
      <v-toolbar
        color="primary"
        dark
      >
        <v-toolbar-title>Activate employee</v-toolbar-title>
      </v-toolbar>
      <v-card>
        <v-card-text v-if="selectedUser !== '' && this.store1Details !== ''">
          Are you sure you want to activate employee? <br><br>
          <div style="display: flex; justify-content: space-around; align-items: center;">
            <div style="text-align: center">
              <strong>{{ userDetails }}</strong><br>
              <em>{{ selectedUserEmail }}</em>
            </div>
            <v-avatar
              size="100,120"
              :tile=true
              color="primary"
              v-if="selectedUser"
            >
              <img :src="userImage" style="height:120px; width:100px;" alt="Avatar">
            </v-avatar>
          </div>
          <br><br>
          <strong>Store ID: {{this.storeCode}}</strong>
          <br><em>{{this.store1Details}}</em>
        </v-card-text>
        <v-card-actions>
          <v-btn dark flat
                 color="error"
                 @click="confirmDialog = false">Close</v-btn>
          <v-spacer></v-spacer>
          <v-btn dark flat
                 color="success"
                 @click="updateUserStore">
            &nbsp;Activate
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

  </v-layout>
</template>

<script>
  import SettingsBody from '../auth/SettingsBody.vue'
  import Vue from 'vue'
  import VeeValidate from 'vee-validate'
  const DEFAULT_STORE_DETAILS = {
    storeId: '',
    name: '',
    address: '',
    city: '',
    state: '',
    country: '',
    zip: ''
  }
  Vue.use(VeeValidate)
  export default {
    name: 'Activate',
    components: {SettingsBody},
    data: () => ({
      store1Details: '',
      userDetails: '',
      apiUrl: process.env.API_URL,
      storeDetails: DEFAULT_STORE_DETAILS,
      selectedParticipants: [],
      participants: [],
      changedInput: false,
      storeCode: '',
      newStoreCode: '',
      selectedNewStore: '',
      selectedUserEmail: '',
      selectedUser: '',
      loading: false,
      confirmDialog: false,
      storeTransferExecuted: false,
      storeTransferExecutedSuccess: false,
      storeTransferExecutedFailed: false,
      dictionary: {
        custom: {
          'slot1.storeCode': {
            required: () => 'Please select employee store'
          },
          'slot1.selectedUserEmail': {
            required: () => 'Please select employee'
          }
        }
      }
    }),
    computed: {
      isButtonDisabled () {
        return (
          this.errors.any('slot1') ||
          !this.storeCode ||
          !this.selectedUser
        )
      },
      user () {
        return this.$store.getters['user/getUserDetails']
      },
      userImage () {
        return 'https://api.cogneti.com/ws/playerservice/user/' + this.selectedUser + '/blob'
      },
      allParticipants () {
        return this.selectedParticipants.length === this.participants.length
      },
      someParticipants () {
        return this.selectedParticipants.length > 0 && !this.allParticipants
      },
      icon () {
        if (this.allParticipants) return 'mdi-close-box'
        if (this.someParticipants) return 'mdi-minus-box'
        return 'checkbox'
      },
      isXs () {
        return this.$vuetify.breakpoint.name === 'xs'
      }
    },
    created () {
      setTimeout(() => {
        this.$store.commit('setIsCompactHeader', false)
      }, 500)
    },
    mounted () {
      this.$validator.localize('en', this.dictionary)
    },
    methods: {
      validateStore () {
        this.errors.remove('slot1.storeCode')

        this.$http({
          url: process.env.API_URL + '/ws/userservice/store/' + this.storeCode,
          method: 'GET'
        }).then((res) => {
          if (res.data.storeId) {
            this.store1Details = res.data.name + ', ' + res.data.address + ', ' + res.data.city + ', ' + res.data.state + ', ' + res.data.zip + ', ' + res.data.country
          }
        }).catch(() => {
          this.store1Details = ''
          this.errors.add({field: 'slot1.storeCode', msg: 'Store not found', scope: 'slot1'})
        })
      },
      validateUser () {
        this.errors.remove('slot1.selectedUserEmail')

        this.$http({
          url: process.env.API_URL + '/ws/playerservice/user/' + this.selectedUserEmail,
          method: 'GET',
          headers: {
            Authorization: 'Bearer ' + this.$auth.token()
          }
        }).then((res) => {
          this.employees = [res.data]
          this.selectedUser = res.data.id
          this.userDetails = res.data.firstName + ' ' + res.data.lastName
        }).catch(() => {
          this.store1Details = ''
          this.errors.add({field: 'slot1.selectedUserEmail', msg: 'Employee not found', scope: 'slot1'})
        })
      },
      updateUserStore () {
        this.confirmDialog = false
        this.loading = true
        this.storeTransferExecuted = false
        this.$validator.validateAll('slot1').then((result) => {
          if (result) {
            this.storeTransferExecuted = true

            this.$http({
              url: `${this.apiUrl}/ws/splat/employee/activate`,
              method: 'POST',
              headers: {
                Authorization: 'Bearer ' + this.$auth.token()
              },
              data: {
                userId: +this.selectedUser,
                storeId: +this.storeCode
              }
            }).then(() => {
              this.$store.commit('flashSuccess', 'Employee activated successfully.')
              this.confirmDialog = false
              this.loading = false
              this.storeTransferExecutedSuccess = true
              this.storeTransferExecuted = true
            }, (err) => {
              this.$store.dispatch('apiError', {errorObj: err, customMsg: 'Unable to process your request'})
              this.storeTransferExecutedFailed = true
              this.confirmDialog = false
              this.loading = false
            })
          }
        })
      },
      goToHome () {
        this.$router.push({name: 'Home'})
      },
      goToSupport () {
        this.$router.push({name: 'ContactSupport'})
      },
      updateStore () {
        this.$validator.validateAll('slot1').then((result) => {
          if (result) {
            console.log('Form Validated')
            this.confirmDialog = true
          }
        })
      },
      userDisplay (user) {
        return user.firstName + '  <' + user.lastName + ' ' + user.email + '>'
      },
      getUser (userId) {
        return this.employees.find(u => u.id === userId) || {firstName: '', lastName: '', email: ''}
      }
    },
    watch: {
    }
  }
  </script>

<style lang="stylus" scoped>
.v-input__slot .v-input--selection-controls:not(.v-input--hide-details) .v-input__slot {
  margin-bottom: 0!important;
}

@media only screen and (max-width: 480px) {
  .ellipsis {
    max-width: 150px;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    display: inline-block;
  }
}
</style>
<style scoped>
td, th {
  padding: 5px;
}
.group-0 {
  background-color: #f9f9f9;
}
.group-1 {
  background-color: #e9e9e9;
}
</style>



// WEBPACK FOOTER //
// src/components/views/manager-actions/Activate.vue